/* LE VOL VERS LE PANIER, ET LE BATTEMENT (client, 07/09/2026, propositions 1 et 2
 * de « Six chemins vers le panier »).
 *
 * Au clic sur un bouton d'ajout — la fiche, la barre d'achat, une carte de
 * rayon, une suggestion, le quiz (tout bouton marqué data-yc-vol) — une bille ambre part DU BOUTON (c'est là qu'est le
 * doigt) et file jusqu'au panier de l'en-tête, en arc, en 650 ms. Le panier
 * l'avale d'un battement (classe yc-panier--bat, assets/yumi-v3.css), puis le
 * thème ouvre le volet comme avant. Le compteur et le total de la pastille,
 * eux, sont tenus par le module de layout/theme.liquid (majPastille).
 *
 * Si le panier de l'en-tête n'est pas à l'écran, ou si la personne refuse les
 * animations, on ne fait que battre. Depuis l'intérieur du tiroir (les
 * suggestions), pareil : l'en-tête est derrière le volet.
 *
 * Chargé sur toutes les pages par layout/theme.liquid, un seul écouteur sur le
 * document : il survit aux redessins du thème.
 */
(function () {
  if (window.__ycVolPanier) return;
  window.__ycVolPanier = true;

  var reduit = function () {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  var cible = function () {
    var p = document.querySelector('.yc-panier .yc-action__icon-wrap');
    if (!p) return null;
    var r = p.getBoundingClientRect();
    if (r.width === 0 || r.bottom < 0 || r.top > window.innerHeight) return null;
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  };

  var battre = function () {
    var b = document.querySelector('.yc-panier');
    if (!b) return;
    b.classList.remove('yc-panier--bat');
    void b.offsetWidth; /* relance l'animation si elle vient de jouer */
    b.classList.add('yc-panier--bat');
    setTimeout(function () {
      b.classList.remove('yc-panier--bat');
    }, 700);
  };

  var voler = function (depuis) {
    var c = cible();
    if (!c || reduit() || typeof depuis.animate !== 'function') {
      battre();
      return;
    }
    var r = depuis.getBoundingClientRect();
    var x0 = r.left + r.width / 2;
    var y0 = r.top + r.height / 2;
    var bille = document.createElement('span');
    bille.className = 'yc-bille';
    bille.setAttribute('aria-hidden', 'true');
    bille.style.left = x0 + 'px';
    bille.style.top = y0 + 'px';
    document.body.appendChild(bille);

    var dx = c.x - x0;
    var dy = c.y - y0;
    /* Un arc : à mi-course, la bille est plus haute que la droite qui joint
       les deux points, comme un objet lancé. */
    var anim = bille.animate(
      [
        { transform: 'translate(0, 0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx * 0.45 + 'px, ' + (dy * 0.5 - 90) + 'px) scale(1.15)', opacity: 1, offset: 0.5 },
        { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(0.3)', opacity: 0.9 },
      ],
      { duration: 650, easing: 'cubic-bezier(0.35, 0.1, 0.3, 1)', fill: 'forwards' }
    );
    var fin = function () {
      bille.remove();
      battre();
    };
    anim.onfinish = fin;
    anim.oncancel = fin;
  };

  document.addEventListener('click', function (ev) {
    if (!(ev.target instanceof Element)) return;
    var bouton = ev.target.closest(
      '.yc-addbtn, .yc-card-btn, .yc-upsell__btn, [data-yc-vol], form[action*="/cart/add"] [type="submit"]'
    );
    if (!bouton || bouton.disabled || bouton.classList.contains('yc-card-btn--out')) return;
    if (bouton.closest('#cart-drawer')) {
      battre();
      return;
    }
    voler(bouton);
  });
})();
